import { GridValueGetterParams } from '@mui/x-data-grid-pro';
import { getTicketId } from 'functions/ticket';

export const ticketIdGetter = (params: GridValueGetterParams<any, any>) => {
  return getTicketId(params.row.ticketId);
};
